export CollectionLayout from './components/CollectionLayout';

export reducer from './reducer';



/** WEBPACK FOOTER **
 ** ./src/app/modules/collection/index.js
 **/